import { useState } from "react";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import {
  actualizarPrecios,
  descartarCotizacion,
  notificarCotizacion,
  existenciaCotizacion,
  getResumen,
  validarCotizacion,
  finalizarCotizacion,
  inyectarCotizacion,
  abrirCotizacionPDF,
  abrirValePDF,
  getdetalle,
  revisarCotizacion,
} from "../../../service/AffariService.js";
import EnviarDialog from "./dialogs/EnviarDialog.js";
import { useGlobalContext } from "../../../Config";
import { useOffline } from "../../../offline/OfflineContext.js";
import {
  guardarCotizacionOffline,
  finalizarCotizacionOffline,
  descartarCotizacionOffline,
} from "../../../offline/offlineCotizacionService.js";

const BotoneraCotizacion = ({
  interfaz,
  codigo,
  onAgregarMaterial,
  idCotizacion,
  onRefresh,
  onNotify,
  setIsDetalleVisible,
  loading,
  setLoading,
  confirming,
  setConfirming,
  onUpdateStocks,
  edit,
}) => {
  const { isDinar, isSack } = useGlobalContext();
  const { offlineMode } = useOffline();
  const navigate = useNavigate();
  const location = useLocation();
  const [isEnviarVisible, setIsEnviarVisible] = useState(false);
  const tipoFromUrl = new URLSearchParams(location.search).get("tipo");
  const tipoRoutes = {
    boleta: "/boleta",
    factura: "/factura",
  };
  const targetRoute =
    tipoRoutes[(tipoFromUrl || "").toLowerCase()] ||
    tipoRoutes[(interfaz || "").toLowerCase()] ||
    "/boleta";

  const handleConfirmar = async () => {
    if (!idCotizacion) {
      if (onNotify)
        onNotify("warn", "Cotización", "ID de cotización no disponible");
      return;
    }
    try {
      setLoading(true);

      const detalleResponse = await getdetalle(
        false,
        false,
        idCotizacion,
        interfaz,
      );
      const items = Array.isArray(detalleResponse)
        ? detalleResponse
        : Array.isArray(detalleResponse?.detalles)
        ? detalleResponse.detalles
        : Array.isArray(detalleResponse?.detalle)
        ? detalleResponse.detalle
        : [];

      if (items.length === 0) {
        if (onNotify)
          onNotify("warn", "Validación", "Debe agregar al menos un producto");
        setLoading(false);
        return;
      }

      const cantidadesInvalidas = items.some((it) => (it.cantidad ?? 0) <= 0);
      if (cantidadesInvalidas) {
        if (onNotify)
          onNotify(
            "warn",
            "Validación",
            "La cantidad de los productos debe ser mayor a 0",
          );
        setLoading(false);
        return;
      }

      const totalSum = items.reduce(
        (sum, it) => sum + (it.total ?? (it.precio ?? 0) * (it.cantidad ?? 0)),
        0,
      );
      if (totalSum <= 0) {
        if (onNotify) onNotify("warn", "Validación", "El total no puede ser 0");
        setLoading(false);
        return;
      }

      await notificarCotizacion(idCotizacion);
      //if (onNotify) onNotify('success', 'Notificado', `Cotización ${idCotizacion}`);
      const existencia = await existenciaCotizacion(idCotizacion);
      await getResumen(idCotizacion);
      // if (onNotify) onNotify('success', 'Resumen actualizado', '');
      if (onRefresh) await onRefresh();
      if (onUpdateStocks && existencia) onUpdateStocks(existencia);
      if (onNotify) onNotify("success", "Cotización Confirmada", "");
      setConfirming(true);
    } catch (error) {
      if (onNotify)
        onNotify("error", "Error al confirmar", error.message || "");
      setConfirming(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-column md:flex-row justify-content-md-end gap-2 mt-2">
      {(!confirming || edit) && (
        <>
          <Button
            label={isSack ? "Agregar Material" : "Agregar Producto"}
            icon="pi pi-plus"
            className="p-button-sm w-full md:w-auto"
            onClick={onAgregarMaterial}
          />
          {isSack && (
            <Button
              label="Actualizar precios"
              icon={loading ? "pi pi-spin pi-spinner" : "pi pi-refresh"}
              className="p-button-outlined p-button-sm w-full md:w-auto"
              onClick={async () => {
                try {
                  setLoading(true);
                  await actualizarPrecios(idCotizacion);
                  if (onNotify)
                    onNotify(
                      "success",
                      "Precios actualizados",
                      `Cotización ${idCotizacion}`,
                    );
                  if (onRefresh) onRefresh();
                } catch (error) {
                  if (onNotify)
                    onNotify(
                      "error",
                      "Error actualizando precios",
                      error.message || "",
                    );
                } finally {
                  setLoading(false);
                }
              }}
            />
          )}
        </>
      )}

      {isDinar && (
        <>
          <Button
            label="Borrar Producto"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-trash"}
            className="p-button-outlined p-button-sm w-full md:w-auto"
          />
          <Button
            label="Finalizar"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
            className="p-button-outlined p-button-sm w-full md:w-auto"
            disabled={loading}
            onClick={async () => {
              if (!idCotizacion) {
                if (onNotify)
                  onNotify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }

              try {
                setLoading(true);

                if (offlineMode) {
                  await finalizarCotizacionOffline(idCotizacion);
                  if (onNotify) {
                    onNotify(
                      "success",
                      "Cotización offline",
                      `Cotización ${idCotizacion} finalizada localmente`,
                    );
                  }
                  navigate(targetRoute);
                  return;
                }

                await validarCotizacion(idCotizacion);
                await finalizarCotizacion(idCotizacion, 0, "");

                if (onNotify) {
                  onNotify(
                    "success",
                    "Cotización finalizada",
                    `Cotización ${idCotizacion}`,
                  );
                }

                navigate(targetRoute);
              } catch (error) {
                if (onNotify)
                  onNotify("error", "Error al finalizar", error.message || "");
              } finally {
                setLoading(false);
              }
            }}
          />
          <Button
            label="Guardar"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
            className="p-button-outlined p-button-sm w-full md:w-auto"
            disabled={loading}
            onClick={async () => {
              if (!idCotizacion) {
                onNotify?.(
                  "warn",
                  "Cotización",
                  "ID de cotización no disponible",
                );
                return;
              }

              try {
                setLoading(true);

                if (offlineMode) {
                  await guardarCotizacionOffline(idCotizacion);
                  onNotify?.(
                    "success",
                    "Cotización offline",
                    `Cotización ${idCotizacion} guardada localmente`,
                  );
                  return;
                }

                onNotify?.(
                  "success",
                  "Cotización",
                  `Cotización ${idCotizacion} guardada`,
                );
              } catch (error) {
                onNotify?.("error", "Error al guardar", error.message || "");
              } finally {
                setLoading(false);
              }
            }}
          />
        </>
      )}

      {interfaz !== "MAYORISTA" && isSack && !confirming && (
        <>
          <Button
            label="Guardar"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
            className="p-button-outlined p-button-sm w-full md:w-auto"
            disabled={loading}
            onClick={async () => {
              if (!idCotizacion) {
                if (onNotify)
                  onNotify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }

              try {
                setLoading(true);

                if (offlineMode) {
                  await guardarCotizacionOffline(idCotizacion);
                  if (onNotify) {
                    onNotify(
                      "success",
                      "Cotización offline",
                      `Cotización ${idCotizacion} guardada localmente`,
                    );
                  }
                  return;
                }

                if (onNotify) {
                  onNotify(
                    "success",
                    "Cotización",
                    `Cotización ${idCotizacion} guardada`,
                  );
                }
              } catch (error) {
                if (onNotify)
                  onNotify("error", "Error al guardar", error.message || "");
              } finally {
                setLoading(false);
              }
            }}
          />
        </>
      )}

      {interfaz === "MAYORISTA" && (
        <>
          <Button
            label="Finalizar"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
            className="p-button-outlined p-button-sm w-full md:w-auto"
            disabled={loading}
            onClick={async () => {
              if (!idCotizacion) {
                if (onNotify)
                  onNotify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }
              try {
                setLoading(true);
                await validarCotizacion(idCotizacion);
                await finalizarCotizacion(idCotizacion, 0, "");
                if (onNotify)
                  onNotify(
                    "success",
                    "Cotización finalizada",
                    `Cotización ${idCotizacion}`,
                  );
                // if (onRefresh) await onRefresh();
                navigate(targetRoute);
              } catch (error) {
                if (onNotify)
                  onNotify("error", "Error al finalizar", error.message || "");
              } finally {
                setLoading(false);
              }
            }}
          />
          <Button
            label="Enviar"
            icon="pi pi-send"
            className="p-button-outlined p-button-sm w-full md:w-auto"
            onClick={() => setIsEnviarVisible(true)}
          />
          <Button
            label="Publicar"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
            className="p-button-outlined p-button-sm w-full md:w-auto"
            disabled={loading}
            onClick={async () => {
              if (!idCotizacion) {
                if (onNotify)
                  onNotify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }
              if (
                !window.confirm(
                  `¿Está seguro de que desea publicar la cotización ${idCotizacion}?`,
                )
              ) {
                return;
              }
              try {
                setLoading(true);
                await revisarCotizacion(idCotizacion);
                if (onNotify)
                  onNotify(
                    "success",
                    "Éxito",
                    "Cotización publicada correctamente",
                  );
                // if (onRefresh) await onRefresh();
                navigate(targetRoute);
              } catch (error) {
                console.error("Error publicando cotización:", error);
                if (onNotify)
                  onNotify("error", "Error", "Error al publicar la cotización");
              } finally {
                setLoading(false);
              }
            }}
          />
        </>
      )}

      {confirming && (
        <>
          {!edit && (
            <Button
              label="Volver"
              icon="pi pi-arrow-left"
              className="p-button-sm w-full md:w-auto"
              onClick={async () => {
                if (onRefresh) await onRefresh();
                setConfirming(false);
              }}
            />
          )}
          <Button
            label="Emitir cotización"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-print"}
            className="p-button-sm w-full md:w-auto"
            outlined
            onClick={async () => {
              if (!idCotizacion) {
                if (onNotify)
                  onNotify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }
              try {
                setLoading(true);
                await validarCotizacion(idCotizacion);
                //if (onNotify) onNotify('success', 'Validación exitosa', `Cotización ${idCotizacion}`);
                await finalizarCotizacion(idCotizacion, 0, "");
                if (onNotify)
                  onNotify(
                    "success",
                    "Finalización exitosa",
                    `Cotización ${idCotizacion}`,
                  );

                abrirCotizacionPDF(idCotizacion);
                if (onNotify)
                  onNotify(
                    "success",
                    "PDF emitido",
                    `Cotización ${idCotizacion}`,
                  );
                // if (onRefresh) onRefresh();
                navigate(targetRoute);
              } catch (error) {
                if (onNotify)
                  onNotify(
                    "error",
                    "Error al emitir",
                    "La cotización esta marcada como despacho y no tiene definido el item flete" ||
                      error.message ||
                      "",
                  );
              } finally {
                setLoading(false);
              }
            }}
          />
          <Button
            label="Emitir vale"
            icon="pi pi-print"
            className="p-button-sm w-full md:w-auto"
            outlined
            onClick={async () => {
              if (!idCotizacion) {
                if (onNotify)
                  onNotify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }
              try {
                setLoading(true);
                await validarCotizacion(idCotizacion);
                //if (onNotify) onNotify('success', 'Validación exitosa', `Cotización ${idCotizacion}`);
                await finalizarCotizacion(idCotizacion, 0, "");
                if (onNotify)
                  onNotify(
                    "success",
                    "Finalización exitosa",
                    `Cotización ${idCotizacion}`,
                  );
                await inyectarCotizacion(idCotizacion);
                if (onNotify)
                  onNotify(
                    "success",
                    "Inyección exitosa",
                    `Cotización ${idCotizacion}`,
                  );

                abrirValePDF(idCotizacion);
                if (onNotify)
                  onNotify(
                    "success",
                    "PDF emitido",
                    `Cotización ${idCotizacion}`,
                  );
                // if (onRefresh) onRefresh();
                navigate(targetRoute);
              } catch (error) {
                if (onNotify)
                  onNotify(
                    "error",
                    "Error al emitir",
                    "La cotización esta marcada como despacho y no tiene definido el item flete" ||
                      error.message ||
                      "",
                  );
              } finally {
                setLoading(false);
              }
            }}
          />
        </>
      )}

      {interfaz !== "MAYORISTA" && isSack && (
        <Button
          label="Actualizar"
          icon={loading ? "pi pi-spin pi-spinner" : "pi pi-refresh"}
          className="p-button-outlined p-button-sm w-full md:w-auto"
          onClick={() => {
            if (onRefresh) onRefresh();
            if (onNotify)
              onNotify(
                "success",
                "Detalles actualizados",
                `cotización ${idCotizacion}`,
              );
          }}
        />
      )}

      <Button
        label="Descartar"
        icon="pi pi-times"
        className="p-button-danger p-button-outlined p-button-sm w-full md:w-auto"
        onClick={async () => {
          try {
            const confirm = window.confirm(
              "¿Estás seguro de descartar la cotización?",
            );
            if (!confirm) return;
            setLoading(true);
            if (offlineMode) {
              await descartarCotizacionOffline(idCotizacion);
            } else {
              await descartarCotizacion(idCotizacion);
            }
            if (onNotify)
              onNotify(
                "success",
                "Cotización descartada",
                `Cotización ${idCotizacion}`,
              );
            setIsDetalleVisible(false);
            navigate(targetRoute);
          } catch (error) {
            if (onNotify)
              onNotify(
                "error",
                "Error descartando cotización",
                error.message || "",
              );
          } finally {
            setLoading(false);
          }
        }}
      />

      {interfaz === "MAYORISTA" && (
        <EnviarDialog
          visible={isEnviarVisible}
          onCancel={() => setIsEnviarVisible(false)}
          codigo={codigo}
          idCotizacion={idCotizacion}
        />
      )}
    </div>
  );
};

export default BotoneraCotizacion;
